import { ReactNode, useRef } from 'react';
import type { AriaPopoverProps } from 'react-aria';
import { DismissButton, Overlay, usePopover } from 'react-aria';
import type { OverlayTriggerState } from 'react-stately';
import styled from 'styled-components';

import Card from 'design-system/components/Card';

const Underlay = styled.div`
  position: fixed;
  inset: 0;
`;

interface CalendarPopoverProps extends Omit<AriaPopoverProps, 'popoverRef'> {
  children: ReactNode;
  noPadding?: boolean;
  state: OverlayTriggerState;
}

const CalendarPopover = ({
  children,
  state,
  offset = 8,
  noPadding,
  ...props
}: CalendarPopoverProps) => {
  const popoverRef = useRef(null);
  const { popoverProps, underlayProps } = usePopover(
    {
      ...props,
      offset,
      popoverRef,
    },
    state,
  );

  const content = (
    <>
      <DismissButton onDismiss={state.close} />
      {children}
      <DismissButton onDismiss={state.close} />
    </>
  );

  return (
    <Overlay>
      <Underlay {...underlayProps} />
      <Card elevated {...popoverProps} ref={popoverRef}>
        {noPadding ? content : <Card.Body>{content}</Card.Body>}
      </Card>
    </Overlay>
  );
};

export default CalendarPopover;
